import React from 'react';
import { Result, Button } from 'antd';
import { Navigate } from 'react-router-dom';
import { usePermissionStore } from '../../../../store/permissionStore';
import { useShallow } from 'zustand/shallow';
import { hasFullAccessRole } from '../../../../utils/fullAccessRole';

interface PermissionRouteProps {
  children: React.ReactNode;
  /** 单一权限码（与 anyOf 二选一） */
  permission?: string;
  /** 满足任一权限即可（与后端 SaMode.OR 场景对齐） */
  anyOf?: string[];
}

const PermissionRoute: React.FC<PermissionRouteProps> = ({
  children,
  permission,
  anyOf,
}) => {
  const { permissions, role, roles, loaded } = usePermissionStore(useShallow((state) => ({
    permissions: state.permissions,
    role: state.role,
    roles: state.roles,
    loaded: state.loaded,
  })));

  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!loaded) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px'
      }}>
        <div>加载权限中...</div>
      </div>
    );
  }

  if (hasFullAccessRole(role, roles)) {
    return <>{children}</>;
  }

  if (anyOf && anyOf.length > 0) {
    const ok = anyOf.some((p) => permissions.includes(p));
    if (!ok) {
      return <NoPermission />;
    }
    return <>{children}</>;
  }

  if (permission) {
    const has = permissions.includes(permission);
    if (!has) {
      return <NoPermission />;
    }
  }

  return <>{children}</>;
};

const NoPermission: React.FC = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: '#f0f2f5'
    }}>
      <Result
        status="403"
        title="403"
        subTitle="抱歉，您没有权限访问此页面。"
        extra={
          <Button type="primary" onClick={() => window.history.back()}>
            返回上一页
          </Button>
        }
      />
    </div>
  );
};

export default PermissionRoute;
